<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="fema_number" name="fema_number" rules="" v-slot="{ errors }">
              <small class="label">FEMA Number</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="fema_number" class="w-full" v-model="form.fema_number" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="cas_number" name="cas_number" rules="" v-slot="{ errors }">
              <small class="label">CAS Number</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="cas_number" class="w-full"  v-model="form.cas_number" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="einecs_ec_number" name="einecs_ec_number" rules="" v-slot="{ errors }">
              <small class="label">EINECS / EC Number</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.einecs_ec_number" name="einecs_ec_number" class="w-full" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="jecfa_number" name="jecfa_number" rules="" v-slot="{ errors }">
              <small class="label">JECFA Number</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="jecfa_number" class="w-full" v-model="form.jecfa_number" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_product_identity_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_staff_trained: false,
          is_protective_clothing_available: false,
          is_protective_clothing_laundered: false,
          is_change_eating_available: false,
          is_personal_items: false,
          is_medical_prior_employment: false,
          is_medical_foreign_vacation: false,
          is_medical_absence: false
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_product_identity_complete  ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialProductIdentity(this.id, this.form))
          this.showSuccessMessage('Raw Material Product Identity Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialProductIdentity(this.form))
          this.showSuccessMessage('Raw Material Product Identity Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialProductIdentity(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_product_identity_complete) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
